import ScrollReveal from "@/components/base/ScrollReveal";

export default function WhyUsSection() {
  const items = [
    {
      icon: "ri-bar-chart-grouped-line",
      title: "量化方法",
      desc: "保單績效、現金流覆蓋率、市場波動與風險缺口，都能被清楚整理與視覺化。",
    },
    {
      icon: "ri-flow-chart",
      title: "模組化流程",
      desc: "從初談、盤點、健診、整合、執行到追蹤，每一步都有清楚方法。",
    },
    {
      icon: "ri-time-line",
      title: "長期陪伴",
      desc: "不是一次性成交，而是在你人生與企業變動時，持續協助檢視與調整。",
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-brand-card border-y border-brand-border">
      <div className="container-main">
        {/* Section Title */}
        <ScrollReveal className="text-center mb-14 md:mb-16">
          <h2 className="text-white font-display font-bold text-[1.5rem] md:text-[2.125rem] leading-[1.4] mb-4">
            為什麼需要保險門神
          </h2>
          <div className="w-[60px] h-[2px] bg-brand-gold mx-auto" />
        </ScrollReveal>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((item, index) => (
            <ScrollReveal key={item.title} delay={index * 120}>
              <div
                className="bg-brand-black border border-brand-border rounded-xl p-6 md:p-8 text-center h-full"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-xl bg-brand-gold/10 mx-auto mb-5">
                  <span className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center text-brand-gold text-xl md:text-2xl">
                    <i className={item.icon} />
                  </span>
                </div>
                <h3 className="text-white font-semibold text-[1.25rem] md:text-[1.625rem] mb-3">
                  {item.title}
                </h3>
                <p className="text-brand-text-secondary text-[1.0625rem] leading-[1.75]">
                  {item.desc}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
